// ES lang
export default {
    type_contract: "Tipo de contrato",
    initial_date: "Fecha inicial",
    final_date: "Fecha final",
    url_contract: "Adjuntar contrato en pdf",
    username: "Nombre de Usuario",
    contract_code: "Código de contrato",
    //   last_name: 'Nombres',
    password: 'Contraseña',
    login: 'Acceso',
    enter_password: "Digite su Contraseña",
    repeat_password: 'Repetir Contraseña',
    email_or_username: 'Usuario',
    email: 'Correo Electrónico',
    name: 'Nombre',
    first_name: 'Nombres',
    last_name: 'Apellidos',
    gender: 'Género',
    birth_date: 'Fecha de Nacimiento',
    document_type: 'Tipo de Documento',
    document_number: 'Número de Documento',
    institute: 'Institución',
    position: 'Cargo',
    loading: 'Cargando',
    login: 'Ingresar',
    copyright: 'Todos los derechos reservados',
    optional: 'Opcional',
    description: 'Descripción',
    nit: 'NIT',
    update: 'Actualizar',
    create: 'Crear',
    category: 'Categoría',
    age_range: 'Rango de Edad',
    third_parties: 'Cliente',
    delete: 'Eliminar',
    submit: 'Enviar',
    save: 'Guardar',
    cancel: 'Cancelar',
    warning: 'Advertencia',
    success: 'Éxito',
    info: 'Información',
    icon: 'Ícono',
    order: 'Orden',
    dimension: 'Dimensión',
    classification: 'Clasificación',
    label: 'Etiqueta',
    state: 'Estado',
    id: 'ID',
    title: 'Título',
    secretaries: 'Secretarías',
    number: 'Número',
    routeType: 'Tipo de Vía',
    minimumLength: 'Longitud Mínima',
    maximumLength: 'Longitud Máxima',
    minimumValue: 'Valor Mínimo',
    maximumValue: 'Valor Máximo',
    maximumSize: 'Tamaño Máximo',
    defaultValue: 'Valor por Defecto',
    measure_unit: 'Unidad de Medida',
    fromMaster: 'Maestro',
    isMultiple: 'Tipo Selección',
    select_option: 'Seleccionar Opción',
    selected: 'Seleccionado',
    remove_option: 'Remover Opción',
    tag_label: 'Agregar esta Opción',
    press_enter_to_create: 'Presionar Enter para crear',
    options_selected: 'opción seleccionada | opciones seleccionadas',
    listOptions: 'Lista de Opciones',
    fromToday: 'Desde fecha actual',
    subject: 'Asunto',
    body: 'Cuerpo',
    city: 'Ciudad',
    blood_type: 'Tipo de Sangre',
    place: 'Nombre del Lugar',
    registration_form: 'Formulario de Registro',
    email_or_username: 'Número de Identificación',
    sign_up: 'Registrar',
    successful_registration: 'Perfil creado satisfactoriamente',
    "Logout": "Salir",
    forms: {
        correct_form_errors: 'Errores'
    },
    validation: {
        alpha: "Este campo solo debe contener letras",
        alpha_dash: "Este campo solo debe contener letras, números y guiones",
        alpha_num: "Este campo solo debe contener letras y números",
        alpha_spaces: "Este campo solo debe contener letras y espacios",
        between: "Este campo debe estar entre {min} y {max}",
        confirmed: "Este campo no coincide",
        double: "Este campo debe ser un número decimal",
        digits: "Este campo debe ser numérico y contener exactamente {length} dígitos",
        dimensions: "Este campo debe ser de {width} píxeles por {height} píxeles",
        email: "Este campo debe ser un correo electrónico válido",
        excluded: "Este campo debe ser un valor válido",
        ext: "Este campo debe ser un archivo válido ({0} {1} {2} {3} {4} {5})",
        image: "Este campo debe ser una imagen",
        integer: "Este campo debe ser un entero",
        length: "El largo dEste campo debe ser {length}",
        max: "Este campo no debe ser mayor a {length} caracteres",
        max_value: "Este campo debe de ser {max} o menor",
        mimes: "Este campo debe ser un tipo de archivo válido",
        min: "Este campo debe tener al menos {length} caracteres",
        min_value: "Este campo debe ser {min} o superior",
        numeric: "Este campo debe contener solo caracteres numéricos",
        oneOf: "Este campo debe ser un valor válido",
        regex: "El formato de este campo no es válido",
        required: "Este campo es obligatorio",
        required_if: "Este campo es obligatorio",
        size: "Este campo debe ser menor a {size}KB",
        sameAsPassword: "Las contraseñas deben ser idénticas",
        minLength: "Este campo debe ser {min} o superior",
        noerrors: "Tiene {number} errores en el formulario, verifique"
    },
    expired_session: 'Su sesión ha expirado, inicie sesión nuevamente',
    login_required: 'Inicio de sesión requerido',
    login_section: {
        init_msg: "Ingrese sus datos para iniciar sesión",
        forgot_your_password: "¿Olvidó su contraseña?",
        forgot_your_password_here: "Recupérela AQUÍ",
        dont_have_an_account: "¿No tienes una cuenta?",
        sign_up: "Regístrate"
    },
    company_info_section: {
        company_name: 'Nombre de la Aplicación',
        phone_number: 'Número de Teléfono',
        primary_color: 'Color Primario',
        whatsapp_number: 'Whatsapp',
        contact_email: 'Email de Contacto',
        support_email: 'Email de Soporte',
        instagram_name: 'Nombre Usuario Instagram',
        instagram_url: 'URL Instagram',
        facebook_name: 'Nombre Facebook',
        facebook_url: 'URL Facebook',
        site_url_back: 'URL Sitio (back)',
        site_url_front: 'URL Sitio (front)',
    },
    projects: {
        page_title: 'Proyectos',
        name: {
            name: 'Nombre Proyecto'
        },
        comments: {
            name: 'Comentarios'
        }
    },
    datatable: {
        recordsperpage: 'Registros por Página',
        filter: 'Filtro',
        typetosearch: 'Buscar',
        clear: 'Limpiar',
        loading: 'Cargando',
        showing: 'Mostrando',
        of: 'de',
        totalrows: 'registros totales'
    },
    calendar: {
        days: {
            Mon: 'Lun',
            Tue: 'Mar',
            Wed: 'Mié',
            Thu: 'Jue',
            Fri: 'Vie',
            Sat: 'Sáb',
            Sun: 'Dom',
            Monday: 'Lunes',
            Tuesday: 'Martes',
            Wednesday: 'Miércoles',
            Thursday: 'Jueves',
            Friday: 'Viernes',
            Saturday: 'Sábado',
            Sunday: 'Domingo'
        },
        months: {
            January: 'Enero',
            February: 'Febrero',
            March: 'Marzo',
            April: 'Abril',
            May: 'Mayo',
            June: 'Junio',
            July: 'Julio',
            August: 'Agosto',
            September: 'Septiembre',
            October: 'Octubre',
            November: 'Noviembre',
            December: 'Diciembre'
        }
    }
}